/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RealizedSavingDashboard {
    getFixupPrototypeFunction() { return RealizedSavingDashboard.fixupPrototype; }

    static newInstance(model: Partial<RealizedSavingDashboard>): RealizedSavingDashboard {
        let obj = Object.assign(new RealizedSavingDashboard(), model);
        RealizedSavingDashboard.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RealizedSavingDashboard>): RealizedSavingDashboard {
        if (!model) return null;
        return RealizedSavingDashboard.newInstance(<RealizedSavingDashboard> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RealizedSavingDashboard) {
        if (!obj) return;

        models.RealizedSavingDashboard.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RealizedSavingDashboard): boolean {
        Object.setPrototypeOf(obj, RealizedSavingDashboard.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.savings_amount === undefined) {
            this.savings_amount = 0;
        }
        if (this.workflow_history) {
            for (let val of this.workflow_history) {
                models.WorkFlowEventHistory.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique id for the resource.
     */
    resource_id: string;

    /**
     * Id for the service account to which the recommendation belongs to.
     */
    service_account_id: string;

    /**
     * Name for the Resource.
     */
    resource_name: string;

    /**
     * Name for the resource filter
     */
    resource_filter: string;

    /**
     * location for the resource
     */
    resource_location: string;

    /**
     * Category for the Resource.
     */
    resource_category: string;

    /**
     * Type for the Resource.
     */
    resource_type: string;

    /**
     * Low level hierarchy for the resource.
     */
    resource: string;

    /**
     * impact for the recommendation
     */
    impact: string;

    /**
     * Current sku for the resource.
     */
    current_sku: string;

    /**
     * Recommended sku for the resource.
     */
    recommended_sku: string;

    /**
     * Name of the recommendation definition.
     */
    recommendation_name: string;

    /**
     * Description of the recommendation definition.
     */
    recommendation_description: string;

    /**
     * Recommendation type for the resource.
     */
    recommendation_type: string;

    /**
     * Recommendation source V2
     */
    source: models.RecommendationSourceV2;

    /**
     * Savings amount for the resource.
     */
    savings_amount: number;

    workflow_history: Array<models.WorkFlowEventHistory>;

    /**
     * Unique Id for the Recommendation.
     */
    recommendation_sys_id: string;

    /**
     * over all status of the workflow.
     */
    workflow_status: models.WorkFlowImpactStatus;

    /**
     * Sys Id of the workflow belongs to
     */
    workflow_id: string;

    /**
     * Sys Id of the tenant where the resource belongs to
     */
    tenant_id: string;

}
